import { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'

import routes from 'const/routes'
import { useAccountSummary } from 'const/syfApiQueries'
import i18n from 'strings/i18n'
import { analyticsConfig } from 'syf-js-utilities/helpers/triggerAnalyticsEvent'
import { Account } from '@syf-api-library/credit-accounts'

import { creditBalanceRefundModalContainerId } from 'const/modalContainerId'
import featureFlags from 'const/featureFlags'
import { useSetAtom } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import { CreditBalanceRefundButtonStyle } from './subcomponents'

interface CreditBalanceRefundButtonProps {
  account: Account
  dataType?: string
}

const CreditBalanceRefundButton = ({
  account,
  dataType
}: CreditBalanceRefundButtonProps): ReactElement => {
  const navigate = useNavigate()
  const setSelectedAccount = useSetAtom(selectedAccountAtom)
  const updateModalStatus = useSetAtom(modalStatusAtom)

  const accountId = account?.info['cipher.accountId']
  const { data: { product } = {} } = useAccountSummary(accountId)
  const manageCreditBalanceRefundButtonId =
    creditBalanceRefundModalContainerId(accountId)

  const handleOnClick = () => {
    analyticsConfig.defaults.Product = product?.type
    analyticsConfig.defaults.ClientName = product?.clientId
    setSelectedAccount(accountId)

    if (featureFlags.isCreditBalanceRefundDrawerEnabled) {
      updateModalStatus(
        'CreditBalanceRefund',
        manageCreditBalanceRefundButtonId
      )
    } else {
      navigate(routes.CREDIT_BALANCE_REFUND)
    }
  }

  return (
    <CreditBalanceRefundButtonStyle
      buttonType="secondary"
      onClick={handleOnClick}
      data-type={dataType || 'manage credit balance'}
      data-reason="manage credit balance"
      data-object="button"
      data-analytics="clicktrackingevent"
      data-test="manage-credit-balance-button"
    >
      {i18n({ button: 'creditBalanceRefund' })}
    </CreditBalanceRefundButtonStyle>
  )
}

export default CreditBalanceRefundButton
